var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
import { ColumnService } from '../../items/columns/column/column.service';
import { ItemBase } from '../../models/item/item-base';
var CampaignNaviComponent = /** @class */ (function (_super) {
    __extends(CampaignNaviComponent, _super);
    function CampaignNaviComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.listTitleKey = '';
        return _this;
    }
    CampaignNaviComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.listTitleKey) {
            this.listTitleKey = this.component.params.listTitleKey;
        }
    };
    CampaignNaviComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignNaviComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignNaviComponent.prototype.setChangeCompData = function (component) {
        this.component.title = component.title;
    };
    CampaignNaviComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-navi',
                    template: "<div id=\"{{ componentName }}\">\n  <ng-template [ngIf]=\"mode === 'goal'\" [ngIfElse]=\"elseBlock\">\n    <p>{{ component.title }}</p>\n  </ng-template>\n  <ng-template #elseBlock>\n    <div class=\"statusList\">\n      <ng-template ngFor let-col [ngForOf]=\"cols\" [ngForTrackBy]=\"trackByCol\">\n        <span *ngIf=\"listTitleKey === col.key\" class=\"statusList_ttl\">{{ rec[col.key] }}</span>\n        <span *ngIf=\"listTitleKey !== col.key\" class=\"statusList_status\">\n          <span class=\"statusList_status_item\">{{ col.label }}\n            <span class=\"statusList_status_item_value\">\n              <column-formlabel *ngIf=\"col.controlType\" [col]=\"col\" [val]=\"rec[col.key]\" [msg]=\"(msg | async)\"></column-formlabel><!--\n              --><ng-template ngFor let-item [ngForOf]=\"col.items\" [ngForTrackBy]=\"trackByCol\"><column-formlabel [col]=\"item\" [val]=\"rec[item.key]\" [msg]=\"(msg | async)\"></column-formlabel></ng-template><!--\n              --><campaign-navigroup *ngIf=\"col.params?.switch\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\"></campaign-navigroup>\n            </span>\n          </span>\n        </span>\n      </ng-template>\n    </div>\n  </ng-template>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignNaviComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignNaviComponent;
}(ContentBaseComponent));
export { CampaignNaviComponent };
var CampaignNaviGroupComponent = /** @class */ (function () {
    function CampaignNaviGroupComponent(service, colservice) {
        this.service = service;
        this.colservice = colservice;
    }
    CampaignNaviGroupComponent.prototype.ngOnInit = function () {
    };
    CampaignNaviGroupComponent.prototype.ngOnChanges = function (changes) {
        this.setSwitch();
    };
    CampaignNaviGroupComponent.prototype.setSwitch = function () {
        if (Object.keys(this.val).length > 0) {
            var swCols = this.colservice.getSwitchItems(this.col, this.val[this.col.key]);
            if (typeof this.val['send_number'] !== 'undefined') {
                var cols = this.service.getTargetMsg(this.val, this.val['send_number'], JSON.stringify(swCols));
                swCols = JSON.parse(cols);
            }
            this.swCols = swCols;
        }
    };
    CampaignNaviGroupComponent.prototype.trackByCol = function (index, col) {
        return JSON.stringify(col);
    };
    CampaignNaviGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-navigroup',
                    template: "<ng-template ngFor let-col [ngForOf]=\"swCols\" [ngForTrackBy]=\"trackByCol\"><!--\n  --><column-formlabel [col]=\"col\" [val]=\"val[col.key]\" [msg]=\"msg\"></column-formlabel><!--\n--></ng-template>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignNaviGroupComponent.ctorParameters = function () { return [
        { type: CampaignService },
        { type: ColumnService }
    ]; };
    CampaignNaviGroupComponent.propDecorators = {
        col: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }]
    };
    return CampaignNaviGroupComponent;
}());
export { CampaignNaviGroupComponent };
//# sourceMappingURL=campaign-navi.component.js.map